import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
}
const options: PricingOption[] = [{
  id: 'megapack',
  emoji: '📘',
  title: 'MEGAPACK PORTUGUÊS',
  description: '6 Tomos + 6 Bonos — Todos los niveles',
  originalPrice: '$51.000',
  price: '$19.990',
  ctaText: '→ QUIERO MIS 6 TOMOS + 6 BONOS',
  ctaHref: 'https://www.profepack.com/cart/48097216168192:1'
}, {
  id: 'elite',
  emoji: '🏆',
  title: 'MEGAPACK + ADAPTACIONES',
  description: '6 tomos + 6 bonos + Kit Adaptaciones Curriculares & Inclusión "Português Sin Barreras"',
  originalPrice: '$69.000',
  price: '$27.990',
  ctaText: '→ SÍ, QUIERO EL MEGAPACK + ADAPTACIONES',
  ctaHref: 'https://www.profepack.com/cart/48135042203904:1',
  isFeatured: true,
  savings: 'AHORRÁS $41.010'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('elite');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-10 sm:py-16 px-4" data-id="element-239">
      <div className="max-w-xl mx-auto" data-id="element-240">
        {/* Header */}
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1 sm:mb-3" data-id="element-241">
          Elegí tu{' '}
          <span className="text-[#39FF14]" data-id="element-242">MegaPack Português Listo:</span>
        </h2>
        <p className="text-gray-300 text-center text-xs sm:text-base mb-5 sm:mb-10" data-id="element-243">
          Las dos opciones incluyen los 6 bonos estratégicos
        </p>

        {/* Options */}
        <div className="space-y-3 sm:space-y-4 mb-5 sm:mb-8" data-id="element-244">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl sm:rounded-2xl p-4 sm:p-6 transition-all ${isFeatured && isSelected ? 'border-2 border-[#39FF14] bg-[#000d08] shadow-[0_0_30px_rgba(57,255,20,0.15)]' : isFeatured ? 'border-2 border-[#39FF14]/50 bg-[#000d08]' : isSelected ? 'border-2 border-[#39FF14] bg-[#0a0a0a]' : 'border border-white/10 bg-[#0a0a0a]'}`} data-id="element-245">
                <div className="flex items-center gap-3 sm:gap-4" data-id="element-246">
                  {/* Radio */}
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#39FF14]' : 'border-white/30'}`} data-id="element-247">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-[#39FF14]" data-id="element-248" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-249">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-250">
                      <span className="text-lg" data-id="element-251">{option.emoji}</span>
                      <span className="text-white font-black text-base sm:text-lg" data-id="element-252">
                        {option.title}
                      </span>
                    </div>

                    {/* Badges */}
                    {isFeatured && <div className="flex items-center gap-2 mt-1.5 sm:mt-2 flex-wrap" data-id="element-253">
                        <span className="bg-[#39FF14] text-black text-[11px] sm:text-xs font-black px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full" data-id="element-254">
                          ⭐ MÁS ELEGIDO
                        </span>
                        {option.savings && <span className="bg-[#39FF14]/20 text-[#39FF14] text-[11px] sm:text-xs font-bold px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full border border-[#39FF14]/40" data-id="element-255">
                            {option.savings}
                          </span>}
                      </div>}

                    <p className="text-gray-400 text-sm mt-1" data-id="element-256">
                      {option.description}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0" data-id="element-257">
                    <div className="text-gray-400 line-through text-xs sm:text-sm" data-id="element-258">
                      {option.originalPrice}
                    </div>
                    <div className={`font-black text-2xl sm:text-3xl ${isFeatured ? 'text-[#39FF14]' : 'text-white'}`} data-id="element-259">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Button */}
        <a href={selectedOption.ctaHref} className="btn-green-pulse block w-full text-center bg-[#39FF14] text-black font-black text-base sm:text-xl py-4 sm:py-5 rounded-xl sm:rounded-2xl hover:bg-[#76FF03] transition-colors" data-id="element-260">
          {selectedOption.ctaText}
        </a>

        {/* Subtitle under CTA */}
        <p className="text-gray-400 text-xs sm:text-sm text-center mt-3 sm:mt-4 italic" data-id="element-261">
          {selected === 'elite' ? 'La opción más elegida por docentes con aulas heterogéneas y alumnos con NEE' : 'El sistema completo para enseñar Português en todos los niveles'}
        </p>

        {/* Trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-300 mt-6 sm:mt-8 bg-[#0a0a0a] border border-[#39FF14]/20 rounded-xl py-3 sm:py-4 px-4 sm:px-6" data-id="element-262">
          <span data-id="element-263">🔒 Pago seguro</span>
          <span data-id="element-264">⚡ Acceso en 5 min</span>
          <span data-id="element-265">🛡️ Garantía 7 días</span>
          <span data-id="element-266">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}